import { shipmentDisputeIdFormat } from "@redotech/redo-model/ids";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { ShipmentDisputeSchema } from "./create-dispute";
import { DisputeStatus } from "./dispute-status";

export const updateDisputeStatus = {
  name: "updateDisputeStatus" as const,
  input: z.object({
    disputeId: shipmentDisputeIdFormat.schema,
    status: createEnum(DisputeStatus),
  }),
  output: z.object({ dispute: ShipmentDisputeSchema }),
};
